import { getProductEdition } from '@atlassian/jira-common-editions/src/get-product-edition/index.tsx';
import { USER_ROLE } from '@atlassian/jira-onboarding-quickstart-core/src/services/model/constants.tsx';
import type { UserRoleTypes } from '@atlassian/jira-onboarding-quickstart-core/src/services/model/types.tsx';
import type { ProjectContext } from '@atlassian/jira-router-resources-project-context/src/services/project-context/types.tsx';
import { SOFTWARE } from '@atlassian/jira-shared-types/src/application-key.tsx';
import { FREE_EDITION } from '@atlassian/jira-shared-types/src/edition.tsx';
import type { TenantContext } from '@atlassian/jira-shared-types/src/tenant-context.tsx';

export const getUserRole = (isSiteAdmin: boolean, isAdmin: boolean): UserRoleTypes => {
	if (isSiteAdmin) return USER_ROLE.SITE_ADMIN;
	if (isAdmin) return USER_ROLE.JIRA_ADMIN;
	return USER_ROLE.END_USER;
};

/**
    Note: This hooks uses to check if the user is included for Invite People To Project Experiment.
    FD ticket: https://hello.atlassian.net/browse/FD-15096
    Included:
         - Project admins and site admins are included
    Excluded:
         - Free Edition Classic Projects are excluded
         - Member/Viewer who doesn't have admin permission are excluded.
 */
export const getCanInvitePeopleToProject = (
	projectContext: ProjectContext | null,
	tenantContext: TenantContext,
) => {
	const isProjectAdmin =
		Boolean(projectContext && projectContext.isProjectAdmin) || tenantContext.isAdmin;
	const isInFreeClassicProject =
		projectContext &&
		!projectContext.simplified &&
		getProductEdition(SOFTWARE, tenantContext) === FREE_EDITION;
	return isProjectAdmin && !isInFreeClassicProject;
};
